import { HorizontalAlignment, PageChangeType, VerticalAlignment } from '@one/web-components';
import { UseVirtualizationProps } from 'commons/hooks';
import { EditableColumn } from 'modules/global/model/editable-column.model';
import React, { CSSProperties } from 'react';

export type HeaderOptions = {
    text: string | React.ReactNode;
    accessibleLabel?: string;
    width?: string;
    align?: HorizontalAlignment;
    valign?: VerticalAlignment;
    stickyColumnsBeginning?: number;
    sortable?: boolean;
    className?: string;
};

export type CellOptions<T> = {
    format?: (data: T) => string | React.ReactNode;
    align?: HorizontalAlignment;
    valign?: VerticalAlignment;
    className?: string;
    style?: CSSProperties;
};

export type RowOptions<T> = {
    cellOptions?: CellOptions<T>;
};

export type FieldConfig<T> = {
    name: string;
    value?: unknown;
    headerOptions: HeaderOptions;
    rowOptions?: RowOptions<T>;
};

export type CustomTableHeaderGroup = {
    id: string;
    text?: React.ReactNode;
    fieldNames: string[];
};

export type ResolvedHeaderGroup = {
    id: string;
    text?: React.ReactNode;
    start: number;
    span: number;
};

export type CustomTableConfig<T> = {
    entity: string;
    columnsToShow?: EditableColumn[];
    fields: FieldConfig<T>[];
    rowStyles?: (data: T) => string;
};

export type PaginationProps = {
    currentPage: number;
    pageSize: number;
    onPageChange: (data: PageChangeType) => void;
};

export type CustomTableVirtualizationProps<T> = {
    enabled?: boolean;
    overscan?: number;
    estimateRowHeight?: UseVirtualizationProps<T>['estimateRowHeight'];
    measureDeps?: UseVirtualizationProps<T>['measureDeps'];
};

export const defaultCellOptions: CellOptions<unknown> = {
    align: 'left',
    valign: 'middle',
};
